import { PermissionTypes } from '@/constants/permissions'
import { MenuLinks } from '@/constants/menu'
import { usePermission } from '@/hooks/usePermission'
import { RootState } from '@/redux/store'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import Preloader from '@/components/Preloader'

interface Props {
	children: React.ReactNode
}

/** Help & Support is tenant Admin only (SupportInquiries permissions). */
const SupportInquiryGuard = ({ children }: Props) => {
	const { userHasPermission } = usePermission()
	const permissionsLoaded = useSelector((state: RootState) => state.Auth.permissionsLoaded)

	if (!permissionsLoaded) {
		return <Preloader />
	}

	if (!userHasPermission(PermissionTypes.Permissions_SupportInquiries_View)) {
		return <Navigate to={MenuLinks.Dashboard} replace />
	}

	return <>{children}</>
}

export default SupportInquiryGuard
